module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage"
  }, [_c('a', {
    attrs: {
      "id": "title38"
    }
  }, [_c('p', {
    staticClass: "p-c-br"
  }, [_vm._v("This book is dedicated to ‘Our dear Channel Islands’ "), _c('br'), _vm._v("(Winston Churchill, 1945); to my husband, Mike, who "), _c('br'), _vm._v("introduced me to the Islands; and to Colin, whose "), _c('br'), _vm._v("name means so much in Guernsey.")])])]), _c('a', {
    attrs: {
      "id": "title38"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1cf88b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783408269_ded01.vue
// module id = 69
// module chunks = 0